import * as Track from "@project/shared/utils/tracking/js/tracking";
import { createModule } from "terrific-singleton";
import { TerrificSpec } from "terrific-singleton/terrific-module";
import { MarketoFormGlobal } from "../../../molecules/marketo-form-global/js/marketo-form-global";

const classes = {
  buttonClose: "js-m-marketo-lightbox__close",
  stateLightboxVisible: "state-m-marketo-lightbox--visible",
  lightboxDialog: "m-marketo-lightbox__dialog",
  lightboxLoading: "m-marketo-lightbox__dialog-loading",
  lightbox: "m-marketo-lightbox",
  stateContentHide: "m-marketo-lightbox--block-hidden",
  blockedMsg: "js-m-marketo-lightbox-blocked-msg",
  formProductName: "js-m-stage-product__headline",
};

@createModule("MarketoLightbox")
export class MarketoLightbox extends TerrificSpec {
  $ctx: JQuery;
  marketoService: MarketoFormGlobal;
  productNameValue: string;

  start(resolve: () => void) {
    this.$ctx = $(this._ctx);
    this.marketoService = new MarketoFormGlobal();

    let $this = this;
    setTimeout(function () {
      var mktoflowId = $this.$ctx.data("t-mktoflowid");
      var pageHref = $this.$ctx.data("t-pagehref");
      var closeButtonDisabled = $this.$ctx.data("t-closebuttondisabled");
      var campaignId = $this.$ctx.data("t-mktocampaign-main-id");
      var themeModeAttribute = $this.$ctx.data("t-thememodeattribute");
      var target = $this.$ctx.data("t-target");
      if (
        mktoflowId != "" &&
        mktoflowId != undefined &&
        mktoflowId.length > 0
      ) {
        if (!Track.isKnownMarketoLead()) {
          $this.getMktoLightboxView(
            mktoflowId,
            pageHref,
            closeButtonDisabled,
            themeModeAttribute,
            campaignId,
            target
          );
        }
      }
    }, 1000);

    setTimeout(function () {
      $("html")
        .find("a")
        .on("click", function (ev: Event) {
          var flowId = $(this).data("mktoflow-id");
          var closeButtonDisabled = $(this).data("mktoflow-close-disabled");
          var videoId = $(this).data("video-id");
          var campaignId = $(this).data("mktocampaign-main-id");
          let href = $(this).attr("href");
          var themeModeAttribute = $(this).data("mkto-themeattribute");
          var target = $(this).attr("target");
          if (flowId != undefined) {
            if (flowId.length > 0) {
              if (!Track.isKnownMarketoLead()) {
                $this.getMktoLightboxView(
                  flowId,
                  href,
                  closeButtonDisabled,
                  themeModeAttribute,
                  campaignId,
                  videoId,
                  target
                );
                return false;
              } else {
                ev.preventDefault();
                $this.getMktoLightboxData(
                  flowId,
                  href,
                  closeButtonDisabled,
                  themeModeAttribute,
                  campaignId,
                  videoId,
                  target
                );
              }
            } else {
              console.log("lightbox: flow-id is empty");
            }
          } else {
            console.log("lightbox: flow-id is undefined");
          }
        });
    }, 1000);

    resolve();
  }

  getMktoLightboxView(
    flowId: string,
    originalHref: string,
    closeButtonDisabled: boolean,
    themeModeAttribute: string = "",
    campaignId: string = "",
    videoId: string = "",
    target: string = ""
  ) {
    // partial view is called, show black-transparent overlay and loading indicator
    this.showLightbox();
    this.showIndicator();

    if (closeButtonDisabled == undefined) {
      closeButtonDisabled = false;
    }

    if (originalHref == undefined) {
      originalHref = "";
    }
    if (
      themeModeAttribute === undefined ||
      themeModeAttribute === null ||
      themeModeAttribute === ""
    ) {
      themeModeAttribute = $("html").hasClass("l-campaign")
        ? "l-campaign"
        : themeModeAttribute;
    }

    var formProductName = $("html").find(`.${classes.formProductName}`);
    if (formProductName.length > 0) {
      this.productNameValue = $(formProductName[0]).text();
    }

    const endpoint = "/partial-updates/marketo/lightboxpartial";
    $.ajax({
      type: "get",
      url: endpoint,
      dataType: "html",
      data: {
        flowId: flowId,
        originLink: originalHref,
        closeButtonDisabled: closeButtonDisabled,
        themeModeAttribute: themeModeAttribute,
        campaignId: campaignId,
        productName: this.productNameValue,
      },
      success: (response: any) => {
        if (response.length > 2) {
          let $dialog = this.$ctx.find(`div.${classes.lightboxDialog}`);

          $dialog.empty();
          $dialog.append(response);
          this.rebindEvents();
          this.loadForm(originalHref, videoId, target);
        } else {
          console.log("lightbox: get partial-view failed");
          this.closeLightbox();
          this.doSubmitAction(false, originalHref, videoId, target);
        }
      },
      complete: () => {},
      error: (xhr: any, status: string, error: string) => {
        console.log(
          `lightbox: get partial-view error, endpoint: ${endpoint}, ${xhr.status}, ${xhr.statusText}, ${error}`
        );
        this.doSubmitAction(false, originalHref, videoId, target);
      },
    });
  }

  getMktoLightboxData(
    flowId: string,
    originalHref: string,
    closeButtonDisabled: boolean,
    themeModeAttribute: string = "",
    campaignId: string = "",
    videoId: string = "",
    target: string = ""
  ) {
    let _this = this;
    let clickEventTriggered = false;
    if (closeButtonDisabled == undefined) {
      closeButtonDisabled = false;
    }

    if (originalHref == undefined) {
      originalHref = "";
    }
    if (
      themeModeAttribute === undefined ||
      themeModeAttribute === null ||
      themeModeAttribute === ""
    ) {
      themeModeAttribute = $("html").hasClass("l-campaign")
        ? "l-campaign"
        : themeModeAttribute;
    }
    this.showLightbox();
    this.showIndicator();

    $.ajax({
      type: "get",
      url:
        window.location.origin +
        "/partial-updates/marketo/lightboxpartialformdata?" +
        "flowId=" +
        flowId +
        "&originLink=" +
        originalHref +
        "&isDisplayForm=true" +
        "&campaignId=" +
        campaignId,
      dataType: "html",
      success: (response: any) => {
        if (response.length > 2) {
          this.closeLightbox();
          let $dialog = _this.$ctx.find(`div.${classes.lightboxDialog}`);
          $dialog.empty();
          $dialog.append(response);
          _this.rebindEvents();
          _this.loadForm("", "", target);
          let $lightboxContainer = _this.$ctx.find(
            `div[data-id="lightboxContainer"]`
          );

          var IsHiddenFormSubmitrequired = $lightboxContainer.data(
            "hidden-form-submit-required"
          );
          var HiddenFormSubmitId = $lightboxContainer.data("lightbox-form-id");
          if (IsHiddenFormSubmitrequired == true) {
            const MktoForms2 = (window as any)["MktoForms2"];
            MktoForms2.whenReady(function (form: any) {
              if (
                HiddenFormSubmitId !== undefined &&
                Number(HiddenFormSubmitId) == form.getId() &&
                clickEventTriggered !== true
              ) {
                form.submit();

                if (originalHref != undefined && originalHref.length > 0) {
                  let downloadTracked = false;

                  if (downloadTracked) {
                    return; 
                  }
                  this.removeAllListeners();
                  clickEventTriggered = true;
                  const link: HTMLAnchorElement = document.createElement("a");
                  link.href = originalHref;
                  link.download = originalHref.split("/").slice(-1)[0];
                  link.target = target;
                  document.body.appendChild(link);
                  link.click();
                  downloadTracked = true;
                  setTimeout(() => {
                    downloadTracked = false;
                    clickEventTriggered = false;
                  }, 500);
                }
                _this.hiddenSubmitForm(HiddenFormSubmitId);
              }
            });
          } else {
            this.triggerClickEvent(originalHref, target);
          }
        } else {
          console.log("lightbox: get partial-view failed");
          this.closeLightbox();
          this.doSubmitAction(false, "", "", "");
        }
      },
      complete: () => {
        this.hideIndicator();
      },
    });
  }
  removeAllListeners() {
    if( $('.m-teaser-large__caption-button').length )  {
    const original: any = document.querySelector(
      ".m-teaser-large__caption-button"
    );
    const clone = original.cloneNode(true); 
    original.parentNode.replaceChild(clone, original);
  }
  }

  triggerClickEvent(originalHref: string, target: string) {
    this.removeAllListeners();

    let downloadTracked = false;
    if (downloadTracked) {
      return; 
    }
    const link: HTMLAnchorElement = document.createElement("a");
    link.href = originalHref;
    link.download = originalHref.split("/").slice(-1)[0];
    link.target = target;
    document.body.appendChild(link);

    // Perform any action, e.g., programmatic click
    link.click();
    downloadTracked = true;
    setTimeout(() => {
      downloadTracked = false;
    }, 500);
    link.remove(); 
  }

  private _marketoFormInitialized: boolean = false;
  private _marketoFormInitializationTimer: number = null;
  loadForm(originalHref: string, videoId: string = "", target: string = "") {
    const MktoForms2 = (window as any)["MktoForms2"];
    let _this = this;

    if (
      typeof MktoForms2 != "object" &&
      this._marketoFormInitializationTimer == null
    ) {
      // Watch for te Marketo script being loaded.
      //	Mechanism based on https://nation.marketo.com/t5/product-blogs/accurately-background-loading-the-mktoforms2-global-object/ba-p/309609
      document.addEventListener(
        "load",
        () => this.loadForm(originalHref, videoId, target),
        true
      );

      // Display failure text after a delay (give the script some time to load)
      this._marketoFormInitializationTimer = window.setTimeout(() => {
        this._marketoFormInitializationTimer = null;
        // Marketo is broken, user has disabled tracking or scripts are blocked
        console.debug("Lightbox: form is blocked");
        _this.hideIndicator();
        _this.displayFormBox();
        _this.$ctx
          .find(`.${classes.blockedMsg}`)
          .removeClass(classes.stateContentHide);
      }, 3000);
    } else if (typeof MktoForms2 == "object" && !this._marketoFormInitialized) {
      document.removeEventListener(
        "load",
        () => this.loadForm(originalHref, videoId, target),
        true
      );
      this._marketoFormInitialized = true;
      if (this._marketoFormInitializationTimer) {
        clearTimeout(this._marketoFormInitializationTimer);
      }

      let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);

      let showMessage = $formContainer
        .parent('div[data-id="lightboxContainer"]')
        .data("show-message");
      let formHref = $formContainer.data("form-href");
      let envId = $formContainer.data("environment-id");
      let formId = $formContainer.data("form-id");
      let $formNode = $formContainer.find("form");

      MktoForms2.loadForm(formHref, envId, formId, function (form: any) {
        try {
          // partial view is called successfully, hide indicator
          _this.hideIndicator();
          _this.displayFormBox();

          form.onSuccess(function (values: any, followUpUrl: string) {
            Track.setKnownMarketoLead(true);
            _this.doSubmitAction(showMessage, originalHref, videoId, target);
            let IsSendDataToGtm = $formNode.data("sc-send-data-to-gtm");
            if (IsSendDataToGtm) {
              var typeOfForm = $formNode.data("show-message");

              const trackdata: {
                event: string;
                form_id: string;
                form_name: string;
                form_destination: string;
                form_submit_text: string;
              } = {
                event: "form_submit",
                form_id: $($formNode).attr("id"),
                form_name: typeOfForm,
                form_destination: "",
                form_submit_text: "",
              };
              Track.gtmTrack(trackdata);
            }
            return false;
          });

          form.onSubmit(function () {
            _this.marketoService.formatPhoneNumber(form);
          });

          if (Track.isKnownMarketoLead()) {
            form.vals({ formVersion: "Known" });
          }
        } catch (error) {
          _this.$ctx
            .find(`.${classes.blockedMsg}`)
            .removeClass(classes.stateContentHide);
        }
      });

      _this.marketoService.initializeMarketoOnScriptLoad();
    }
  }

  hiddenSubmitForm(hiddenForm: any) {
    let formId = hiddenForm;
    let formName = jQuery('div[data-form-id="' + formId + '"] form').attr(
      "data-form-name"
    );
    const trackdata: {
      event: string;
      form_id: string;
      form_name: string;
      form_destination: string;
      form_hidden_submit_text: string;
    } = {
      event: "hidden_form_submit",
      form_id: formId,
      form_name: formName.toString(),
      form_destination: "",
      form_hidden_submit_text: "",
    };
    Track.gtmTrack(trackdata);
  }
  rebindEvents() {
    let $this = this;

    this.$ctx.find(`.${classes.buttonClose}`).on("click", function () {
      $this.closeLightbox();
    });
  }

  removeCloseEvents() {
    let $this = this;

    this.$ctx.find(`.${classes.buttonClose}`).off("click", function () {
      $this.closeLightbox();
    });
  }

  showLightbox() {
    $("html")
      .find(`.${classes.lightbox}`)
      .addClass(classes.stateLightboxVisible);
    $("html").addClass("no-scrolling--without-scrollbar");
  }

  closeLightbox() {
    this.$ctx.removeClass(classes.stateLightboxVisible);
    this.$ctx.find(`.${classes.lightboxDialog}`).empty();
    $("html").removeClass("no-scrolling--without-scrollbar");
    this._marketoFormInitialized = false;
    this._marketoFormInitializationTimer == null;
  }

  displayConfirmationBox() {
    let $confirmContainer = this.$ctx.find(
      `div[data-id="confirmationContainer"]`
    );
    $confirmContainer.removeClass(classes.stateContentHide);
  }

  displayFormBox() {
    let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);
    $formContainer.removeClass(classes.stateContentHide);
  }

  hideFormBox() {
    let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);
    $formContainer.addClass(classes.stateContentHide);
  }

  hideIndicator() {
    let $dialog = this.$ctx.find(`.${classes.lightboxDialog}`);
    $dialog.removeClass(classes.stateContentHide);

    let $indicator = this.$ctx.find(`.${classes.lightboxLoading}`);
    $indicator.addClass(classes.stateContentHide);
  }

  showIndicator() {
    let $dialog = this.$ctx.find(`.${classes.lightboxDialog}`);
    $dialog.addClass(classes.stateContentHide);

    let $indicator = this.$ctx.find(`.${classes.lightboxLoading}`);
    $indicator.removeClass(classes.stateContentHide);
  }

  doSubmitAction(
    showConfirmationMsg: boolean,
    originalHref: string,
    videoId: string = "",
    target: string = ""
  ) {
    // confirmation message
    if (showConfirmationMsg) {
      this.hideFormBox();
      this.displayConfirmationBox();

      // go to original link
    } else {
      this.closeLightbox();
      if (videoId.length > 0) {
        //play
        $('[data-video-id="' + videoId + '"] .mi-big-play-cover').trigger(
          "click"
        );
        $('[data-video-id="' + videoId + '"] .js-a-video__locked').remove();
      } else {
        if (originalHref != undefined && originalHref.length > 0) {
          this.triggerClickEvent(originalHref, target);
        }
      }
    }
    //unlock
    $(".a-video--locked").removeClass("a-video--locked");
    $(".m-download-item--locked").removeClass("m-download-item--locked");
    $(".m-download-table__item--locked").removeClass(
      "m-download-table__item--locked"
    );
    $(".m-hero-article-stage--locked").removeClass(
      "m-hero-article-stage--locked"
    );
    $(".m-scrollable-teaser-item--locked").removeClass(
      "m-scrollable-teaser-item--locked"
    );
    $(".m-talk--locked").removeClass("m-talk--locked");
    $(".m-teaser-large--locked").removeClass("m-teaser-large--locked");
    $(".o-teaser-content-area__item").each((i, e) => {
      const $teaser = $(e).children();
      const classList = $teaser.attr("class");
      const className = classList.split(" ");
      $teaser.removeClass(className[0] + "--locked");
    });
  }
  stop() {}
}
